import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TemplatesService } from '../templates/templates.service';
import { ToastrService } from 'ngx-toastr';
import { defineComponents, IgcRatingComponent } from 'igniteui-webcomponents';
defineComponents(IgcRatingComponent);


@Component({
  selector: 'app-rating-modal',
  templateUrl: './rating-modal.component.html',
  styleUrls: ['./rating-modal.component.css']
})
export class RatingModalComponent {
  ratinglist: any;
  dataRating:any;
  existingUser:any
  empId: number;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<RatingModalComponent>) {

  }
  starRating = 0;
  ngOnInit() {
    this.empId = parseInt(localStorage.getItem('Id'));
    this.ratinglist = this.data.ratings;
    this.data.empId = this.empId;
    this.existingUser = this.data.ratings.find(item=>item.empId === this.empId);
    this.data.ratings = this.data.ratings || 0;
    this.data.starRating = 0;
  }



  ratingChanged(event) {
    this.data.starRating = event.detail

  }
  AddComments(event) {
    this.data.Comments = $("#comments").val();
  }

  close() {

    this.data
    this.dialogRef.close()
  }
  closeDialog() {

    this.dialogRef.close(this.data)
  }
  closeDialog1() {
    this.dataRating = this.data.ratings.find(item=>item.empId === this.empId);
    this.dataRating.rating = this.data.starRating || this.data.ratings.rating;
    this.dataRating.comments = this.data.Comments || this.data.ratings.comments;
    this.dataRating.empId = this.empId;
    this.dialogRef.close(this.dataRating);

  }

}
